import { UnorderedListOutlined } from '@ant-design/icons';
import { message, Popover, Radio, Space, Spin, Tooltip } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { getCoberturaLabel } from '../functions/opcionesSubcobertura';
import { instanceRef } from '../utils/axios';

const SubcoberturasRadioListPopover = ({
  urlFetchList,
  checked,
  handleChange,
  subcoberturasParaExcluir,
  plan
}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [dataOriginalList, setDataOriginalList] = useState([]);

  const handleRadioChange = (e) => {
    setSelectedItem(e.target.value);
    handleOk(e.target.value);
  };

  const fetch = useCallback(
    async (paramsProccess) => {
      try {
        setLoading(true);
        try {
          const response = await instanceRef.instance.get(urlFetchList, {
            params: paramsProccess
          });
          if (response.data?.data) {
            const datos = response.data?.data?.rows
              ? response.data?.data?.rows
              : response.data.data;

            setDataOriginalList(datos);
            const preparedList = datos.map((item) =>
              getCoberturaLabel(item.subcobertura, true)
            );
            setList(preparedList);
            setLoading(false);
          }
        } catch (error) {
          message.error(error);
          setLoading(false);
        }
      } catch (error) {
        message.error(error);
        setLoading(false);
      }
      setLoading(false);
    },
    [urlFetchList]
  );

  const handleOk = useCallback(
    async (id) => {
      if (id) {
        const { subcobertura } = dataOriginalList.find(
          (item) => item.subcobertura.id === id
        );
        handleChange(subcobertura);
      }
    },
    [dataOriginalList, handleChange]
  );

  const content = (
    <Spin spinning={loading}>
      <Space direction="vertical">
        <Radio.Group onChange={handleRadioChange} value={selectedItem}>
          {list.map((item, index) => (
            <div key={index}>
              <Radio
                value={item.id}
                disabled={subcoberturasParaExcluir?.find(
                  (e) =>
                    e.controlProductoCobertura.id_subcobertura === item.id &&
                    e.id_aseguradora === plan.aseguradoraProducto.id_aseguradora
                )}
              >
                {item.label}
              </Radio>
            </div>
          ))}
        </Radio.Group>
        {/* <Button key="2" type="primary" size="small" onClick={handleOk}>
        Actualizar
      </Button> */}
      </Space>
    </Spin>
  );

  useEffect(() => {
    if (list && list.length > 0) {
      setSelectedItem(checked.id);
    }
  }, [list, checked, handleOk]);

  return (
    <Popover
      content={content}
      title="Coberturas"
      trigger="click"
      loading={loading}
    >
      <Tooltip title="Selección de coberturas" placement="bottom">
        <UnorderedListOutlined
          type="text"
          size="middle"
          onClick={() => fetch()}
          style={{ color: 'rgba(0,0,0,.45)' }}
        />
      </Tooltip>
    </Popover>
  );
};

export default SubcoberturasRadioListPopover;
